// import external dependencies
import 'jquery';
import feather from 'feather-icons';
// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import recipes from './routes/recipes';
import mealPlans from './routes/meal-plans';
import curate from './routes/curate';
import foods from './routes/foods';
import body from './routes/body';
import howItWorks from './routes/how-it-works';
import dislikes from './routes/dislikes';

import {MDCSnackbar} from '@material/snackbar';

// import {MDCFoo, MDCFooFoundation} from '@material/foo';
// import MDCSnackbar from '@material/snackbar';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  recipes,
  curate,
  foods,
  body,
  dislikes,
  howItWorks,
  mealPlans,
});

window.feather = feather;

// Load Events
jQuery(document).ready(() => {
  routes.loadEvents();
  feather.replace();
  
  // const snackbar = new MDCSnackbar(document.querySelector('.mdc-snackbar'));

  // Set active nav item
  var url = window.location.href;
  // console.log(window.location);
  // console.log(url);
  $('.nav-wrapper .nav-primary').find('.active').removeClass('active');
  $('.nav-wrapper .nav-primary li a').each(function () {
    console.log(this.href);
      if (this.href.replace(/\/+$/,'') + '/' == url.replace(/\/+$/,'') + '/') {
          $(this).parent().addClass('active');
      }
  }); 
	
	// Show snackbar message if user clicks reply or comment but isn't logged in
    var $dropdown_button = $('.reply-button');
	$dropdown_button.on('click', function (e) {
		e.preventDefault();
		let postId = $('.add-to-favorite').data('post-id');
		let userId = $('.add-to-favorite').data('user-id');
		if (!postId || !userId) {
			// Show snackbar message if user not logged in
			const snackbar = new MDCSnackbar(document.querySelector('.mdc-snackbar'));
			const snackbarActionButton = document.querySelector('.mdc-snackbar__action');
			snackbarActionButton.addEventListener('click', function() {
				// console.log(e);
				window.location = '/quiz/food';
			});
		snackbar.labelText = 'Ah, you\'ll need to create a free account to leave a comment.';
		snackbar.actionButtonText = 'Create Account';
		snackbar.open();
		return;
		}
	});
	
	// Show snackbar message if user clicks diet type dropdown but isn't logged in
		$dropdown_button = $('#dietTypeDropdown, #dietTypeDropdownMobile');
		$dropdown_button.on('click', function (e) {
		e.preventDefault();
		let postId = $('.add-to-favorite').data('post-id');
		let userId = $('.add-to-favorite').data('user-id');
		if (!postId || !userId) {
			// Show snackbar message if user not logged in
			const snackbar = new MDCSnackbar(document.querySelector('.mdc-snackbar'));
			const snackbarActionButton = document.querySelector('.mdc-snackbar__action');
			snackbarActionButton.addEventListener('click', function(e) {
				console.log(e);
				window.location = '/quiz/food';
			});
		snackbar.labelText = 'Ah, you\'ll need to create a free account to change diet types.';
		snackbar.actionButtonText = 'Create Account';
		snackbar.open();
		return;
		}
	});

});


// WEBPACK FOOTER //
// ./scripts/main.js